import React from 'react';
import { PapiComment } from '@wix/da-papi-types';
import { BadgeStatisticsClickBiEvent, BiData } from '@wix/da-bi/pkg/events';
import { getRecipientForComment } from '../../../utils';
import { getCommentNotificationQueue } from '../../../../Comment/utils';
import { ResourceType } from '../../../../types/resource';
import CoreBadgeList from '../../CoreBadgeList';

interface Props {
  comment: PapiComment;
  className?: string;
}

const CommentCoreBadgeList: React.FC<Props> = ({ comment, className }) => (
  <CoreBadgeList
    className={className}
    badges={comment.awardedBadges ?? []}
    recipient={getRecipientForComment(comment)}
    targetTypeId={ResourceType.DEVIATION}
    targetItemId={comment.commentId}
    notificationQueueName={getCommentNotificationQueue(comment)}
    biData={BiData<BadgeStatisticsClickBiEvent>({
      evid: 323,
      sectionname: 'comments',
      typeid: ResourceType.COMMENT,
      itemid: comment.commentId,
    })}
    size="small"
  />
);
CommentCoreBadgeList.displayName = 'CommentCoreBadgeList';

export default CommentCoreBadgeList;
